//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import constant from '~/const';

export default {
  props: {
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      email: '',
      status: 0,
    };
  },

  computed: {
    statusList() {
      return constant.admin.ADMIN_STATUS_LIST;
    },

    isPossibleApply() {
      const { email, status, loading } = this;
      return !loading && email.trim() !== '' && (status >= 0 && status <= 3);
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },

    apply() {
      const { email, status } = this;
      const payload = {
        Email: email,
        AdminStatus: status,
      };

      this.$emit('apply', payload);
    },
  },
};
